import React, { useEffect, useState } from "react";
import api from "../../api/axios";
import Input from "../ui/Input";
import { toast, ToastContainer } from "react-toastify";
import Button from "../ui/Button";
import ModelSelect from "../ui/ModelSelect";

const ControlProduction = () => {
  const [models, setModels] = useState([]);
  const [posts, setPosts] = useState([]);
  const [selectedModel, setSelectedModel] = useState("");
  const [selectedPost, setSelectedPost] = useState("");
  const [production, setProduction] = useState(0);
  const [retouch, setRetouch] = useState(0);
  const [totalRetouch, setTotalRetouch] = useState(0);
  const [entre, setEntre] = useState(0);
  const [encore, setEncore] = useState(0);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [productionP , setProductionP] = useState(0);

  useEffect(() => {
    const fetchModels = async () => {
      try {
        const response = await api.get("/models", {
          params: { available_only: true },
        });
        setModels(response.data);
      } catch (error) {
        console.error("Error fetching models:", error);
      }
    };

    const fetchPosts = async (selectedModel) => {
      try {
        const response = await api.get("/posts", {
          params: { model_id: selectedModel },
        });
        setPosts(response.data);
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };

    fetchModels();
    if(selectedModel) {
      fetchPosts(selectedModel);
    }
  }, [selectedModel]);

  const fetchProductionSummary = async (modelId = selectedModel) => {
    if (!modelId) return;

    try {
      const [controlResponse, repassageResponse] = await Promise.all([
        api.get(`/control_production/${modelId}`),
        api.get(`/repassage_production/${modelId}`),
      ]);
      const controlTotal = Number(controlResponse.data.value) || 0;
      const inputTotal = Number(repassageResponse.data.total_value) || 0;

      setProductionP(controlTotal);
      setTotalRetouch(Number(controlResponse.data.retouch) || 0);
      setEntre(inputTotal);
      setEncore(Math.max(0, inputTotal - controlTotal));
    } catch (error) {
      console.error("Error fetching final-control data:", error);
      toast.error("Impossible de charger les données du contrôle final.");
    }
  };

  useEffect(() => {
    if (!selectedModel) {
      setProduction(0);
      setRetouch(0);
      setProductionP(0);
      setTotalRetouch(0);
      setEntre(0);
      setEncore(0);
      return;
    }
    fetchProductionSummary(selectedModel);
  }, [selectedModel]);
  
  const handleModelChange = (e) => {
    setSelectedModel(e.target.value);
    setSelectedPost("");
    setProduction(0);
    setRetouch(0);
  };

  const handlePostChange = (e) => {
    setSelectedPost(e.target.value);
  };

  const handleChange = async (direction, type) => {
    let newValue;
    if (type === "production") {
      newValue = direction === "next" ? production + 1 : production - 1;
      if (newValue < 0) newValue = 0;
      const newEncore = entre - newValue;
      if (newEncore < 0) {
        toast.error("Encore cannot be less than 0");
        return;
      }
      setProduction(newValue);
      await updateProduction(newValue);
    } else if (type === "retouch") {
      newValue = direction === "next" ? retouch + 1 : retouch - 1;
      if (newValue < 0) newValue = 0;
      setRetouch(newValue);
    }
  };

  const updateProduction = async (newProduction) => {
    setIsButtonDisabled(true);
    try {
      await api.post(`/control_production/${selectedModel}`, {
        value: newProduction,
      });
    } catch (error) {
      console.error("Error updating production data:", error);
    } finally {
      setIsButtonDisabled(false);
    }
  };

  const handleRetouchSubmit = async () => {
    if (!selectedModel || retouch <= 0) {
      toast.error("Veuillez saisir une quantité de retouches.");
      return;
    }
    if (!selectedPost) {
      toast.error("Please select a post before submitting retouch.");
      return;
    }

    setIsButtonDisabled(true);
    try {
      await api.post(`/control_production/${selectedModel}`, {
        value: 0,
        retouch,
        posts: String(selectedPost),
      });

      setRetouch(0);
      setSelectedPost("");
      await fetchProductionSummary();
      toast.success("Retouches enregistrées avec succès.");
    } catch (error) {
      console.error("Error updating retouch data:", error);
      toast.error(error.response?.data?.error || "Impossible d'enregistrer les retouches.");
    } finally {
      setIsButtonDisabled(false);
    }
  };

  const handleValueChange = async (name , value) => {
    const newValue = Math.max(0, Number(value) || 0);
    const newEncore = entre - newValue;

    if (newEncore < 0) {
      toast.error("Encore cannot be less than 0");
      return;
    }

    setProduction(newValue);

  };

  const handleSave = async () => {
    if (!selectedModel) return;
    setIsButtonDisabled(true);
    try {
     await api.post(`/control_production/${selectedModel}`, {
        value: production,
      });

      await fetchProductionSummary();
      setProduction(0);
      toast.success("Record saved successfully");
    } catch (error) {
      console.error("Error saving production data:", error);
      toast.error(error.response?.data?.error || "Impossible d'enregistrer la production.");
    } finally {
      setIsButtonDisabled(false);
    }
  }

  const handleUpdate = async () => {
    if (!selectedModel) return;
    setIsButtonDisabled(true);
    try {
      await api.post(`/control_production_update/${selectedModel}`, {
        value: production,
      });

      await fetchProductionSummary();
      setProduction(0);
      toast.success("Record saved successfully");
    } catch (error) {
      console.error("Error saving production data:", error);
      toast.error(error.response?.data?.message || error.response?.data?.error || "Impossible de modifier la production.");
    } finally {
      setIsButtonDisabled(false);
    }
  }

  const handleReset = async () => {
    if (!selectedModel) return;
    setIsButtonDisabled(true);
    try {
      await api.delete(`/control_production/${selectedModel}`)
      await fetchProductionSummary();
      toast.success("Production remise à zéro.");
    } catch (error) {
      console.error("Error saving production data:", error);
toast.error("Impossible de remettre la production à zéro.");    } finally {
      setIsButtonDisabled(false);
    }
  }



  const selectedModelData = models.find((model) => model.id == selectedModel);

  return (
    <div className="ml-[19%] pt-[6rem]">
      <ToastContainer />
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold">Control Final</h2>
        <ModelSelect
          className="w-full max-w-md pr-6"
          value={selectedModel}
          onChange={handleModelChange}
          models={models}
        />
      </div>
      {selectedModelData && (
        <div className="w-full pr-6">
          <div
            key={selectedModelData.id}
            className="flex items-center justify-between"
          >
            <h3 className="font-semibold">{selectedModelData.category}</h3>
            <h3 className="font-semibold">{selectedModelData.client}</h3>
          </div>
        </div>
      )}
      <div className="w-full pr-6">
        {selectedModelData && (
            <div className="flex my-5 items-center justify-between">
                    <h3 className="font-semibold text-xl">Encour: {encore}</h3>
                    <h3 className="font-semibold text-xl">Total: {productionP}</h3>
            </div>        
        )}
          {selectedModel && <button
            onClick={handleReset}
            disabled={isButtonDisabled}
            className="mt-4 bg-red-500 text-white p-2 rounded"
          >
            Reset
          </button>}

      </div>

      <div className="flex justify-between items-center">
        {selectedModel && (
                 <div className="flex flex-col p-5 mt-[2rem] mb-4 shadow-md w-fit p-1 rounded border">
                 <Input
                   handleChange={handleValueChange}
                   name={"production"}
                   label="Total Production"
                   text={production ? production.toString() : "0"}
                 />
                 <div className="flex items-center justify-between">
                   <button
                      onClick={handleSave}
                      className="mt-4 w-[48%] bg-blue-500 text-white p-2 rounded"
                    >
                      Save
                    </button>
                    <button
                      onClick={handleUpdate}
                      className="mt-4 w-[48%] bg-yellow-500 text-white p-2 rounded"
                    >
                      Modifier
                    </button>
                 </div>
             </div>
        )}
        {selectedModel && (
          <div className="flex flex-col items-center mx-auto mt-[2rem] mb-4 shadow-md w-fit p-3 rounded border">
            <h3 className="font-semibold">Total Retouch: {totalRetouch}</h3>
            <div className="flex items-center">
              <button
              className="font-semibold text-[18px] bg-red-300 hover:bg-red-400 p-2 transition duration-300 rounded mt-9 w-[70px] border border-black m-[12px] mt-4"
              onClick={() => handleChange("prev", "retouch")}
                disabled={isButtonDisabled}
              >
                -
              </button>
              <Input
                handleChange={() => {}}
                name={"retouch"}
                disabled
                placeholder="Total Retouch"
                text={retouch ? retouch.toString() : "0"}
              />
              <button
              className="font-semibold text-[18px] bg-green-300 hover:bg-green-400 p-2 transition duration-300 rounded mt-9 w-[70px] border border-black m-[12px] mt-4"
              onClick={() => handleChange("next", "retouch")}
                disabled={isButtonDisabled}
              >
                +
              </button>
              <div>
                <select
                  id="select"
                  className="block w-fit mt-4 mr-4 outline-0 p-[.5rem] border border-[#b3b3b3] focus:border-2 focus:border-[#2684ff] rounded"
                  value={selectedPost}
                  onChange={handlePostChange}
                  disabled={retouch === 0}
                >
                  <option value="">Select Post</option>
                  {posts.map((post, index) => (
                    <option key={index} value={post.id}>
                      {post.name}
                    </option>
                  ))}
                </select>
              </div>
              <Button
                classes={"bg-blue-500 mt-4"}
                handlePress={handleRetouchSubmit}
                disabled={isButtonDisabled}
              >
                Submit
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ControlProduction;
